import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSparks = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 58",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M32.77 0h-2v.56c0 13.4-10.92 23.92-24.81 23.92h-.58v3.86c13.87-.32 25.04 9.93 25.38 23.3v1.23H34.8v-.61c0-13.38 10.91-23.9 24.79-23.9h.58v-3.88c-13.89.3-25-9.96-25.31-23.35l-.01-.57V0h-2.07Z",
			fill: "url(#a)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0 58h11V47.48H0V58Z",
			fill: "url(#a)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M64 7.19V0h-7.68v7.19H64Z",
			fill: "url(#a)"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "a",
			x1: 32.77,
			y1: 0,
			x2: 32.77,
			y2: 52.87,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#DF2BE3" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#959013"
			})]
		}) })
	]
});
export default SvgSparks;
